// src/ProtectedRoute.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUser } from "./UserContext";
import { MANAGEMENT_ROLES, hasAnyPermission } from "./utils/roleManagement";

// Giriş kapıları ayrıdır: yönetim ekranlarına giren oturumsuz kullanıcı
// /yonetim/giris sayfasına, üye ekranlarına giren /giris sayfasına gönderilir.
const loginPathFor = (allowedRoles) =>
  allowedRoles.length && allowedRoles.every((role) => MANAGEMENT_ROLES.includes(role))
    ? "/yonetim/giris"
    : "/giris";

const ProtectedRoute = ({ roleRequired, permission, children }) => {
  const { user, isLoading } = useUser();
  const location = useLocation();

  if (isLoading) return <div>Yetki kontrol ediliyor...</div>;

  const allowedRoles = Array.isArray(roleRequired) ? roleRequired : roleRequired ? [roleRequired] : [];

  if (!user) {
    // Giriş sonrası kullanıcıyı gitmek istediği sayfaya döndürebilmek için
    // hedef yol state ile taşınır. Sorgu da korunur: WhatsApp'tan gelen
    // "/panel?mac=12" bağlantısı girişten sonra doğrudan o maçın kadrosunu açar.
    return <Navigate to={loginPathFor(allowedRoles)} replace state={{ from: `${location.pathname}${location.search || ""}` }} />;
  }

  if (allowedRoles.length && !allowedRoles.includes(user.role)) return <Navigate to="/" replace />;

  // Rol yetiyor ama panelden bu iş için yetki verilmemişse sayfa açılmaz.
  // Dizi verilirse yetkilerden biri yeterlidir.
  const permissions = Array.isArray(permission) ? permission : permission ? [permission] : [];
  if (permissions.length && !hasAnyPermission(user, permissions)) return <Navigate to="/" replace />;

  return children;
};

export default ProtectedRoute;
